import { AppLayout } from './AppLayout';

const name = 'AppLayout';

export { name, AppLayout };
